/**
 * Audit HTTP service (PX-W6.2) — the org audit log's list and export verbs.
 *
 * Export goes through the shared transport as a Blob download (the endpoint
 * is Bearer-gated; a plain anchor cannot carry the Authorization header).
 * The query string is shared by both verbs so a filtered list exports the
 * same rows it displays.
 */

import { apiClient } from '@/services'

import type { AuditPage } from './types'

/** Strip empty filters so the server's defaults (blank = no clause) apply. */
const cleanParams = (filters: Record<string, string | number | undefined>) => {
  const params: Record<string, string | number> = {}
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== '') params[key] = value
  }
  return params
}

export const auditHttp = {
  /** One cursor-paged slice of the log, newest first. */
  list(
    filters: { action?: string; entityType?: string; actorUserId?: string },
    cursor?: string,
    limit = 50
  ): Promise<AuditPage> {
    return apiClient.get<AuditPage>('/{orgId}/audit', {
      params: cleanParams({ ...filters, cursor, limit })
    })
  },

  /** The same query as a JSON blob download. */
  export(filters: { action?: string; entityType?: string; actorUserId?: string }): Promise<Blob> {
    return apiClient.get<Blob>('/{orgId}/audit/export', {
      params: cleanParams({ ...filters, format: 'json' }),
      responseType: 'blob'
    })
  }
}
